import React from "react";
import liaisonOfficer from "../../assets/images/svg/liaisonOfficer.svg";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import AuthStore from "../../store/AuthStore";

const AddManager = observer(() => {
  const navigate = useNavigate();
  return (
    <div className="add_manager_out">
      <div className="add_man_inside_cont">
        <img src={liaisonOfficer} alt="" />
        <p className="blueTextColor">
          If you have appointed a Family Office Manager, you can give them
          access to view your holdings
        </p>
        <div
          className="add_btn_container"
          onClick={() => {
            window.scrollTo(0, 0);
            AuthStore.updateLoadingFullScreen(true);
            navigate("/settings/add-family-office-team");
          }}
        >
          <h2>Add Manager</h2>
          <button>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
            >
              <path
                d="M7.99805 6.60547H13.6221V8.02734H7.99805V14.1465H6.46191V8.02734H0.952148V6.60547H6.46191V0.689453H7.99805V6.60547Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
});

export default AddManager;
